import { Box, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import data from '../../data/data.json';
import { useCallback, useEffect, useState } from "react";
import {isMobile} from 'react-device-detect';
import Particles from '../../components/effects/particles/particles';
import YouTube from 'react-youtube';

const GamePlayView = () => {
    const [height, setHeight] = useState(window.innerHeight);
    const [isViewWidthSmall, setIsViewWidthSmall] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const header = document.getElementById('header');
            const headerHeight = header ? header.offsetHeight : 0;

            const height = window.innerHeight - headerHeight - 100;

            setHeight(height);

            const isWidthSmall = window.innerHeight > window.innerWidth || window.innerWidth < height * 1.77;

            setIsViewWidthSmall(isWidthSmall);
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [youtubeVideoError, setYoutubeVideoError] = useState(false);

    const OnYoutubeError = useCallback((event) => {
        // // The event contains a data property with the error code.
        // const errorCode = event.data;

        // // Map the YouTube error code to a readable message
        // let errorMessage = '';
        
        // switch (errorCode) {
        //     case 2:
        //         errorMessage = t(`errors.youtube_video.invalid`);
        //         break;
        //     case 5:
        //         errorMessage = t(`errors.youtube_video.player_error`);
        //         break;
        //     case 100:
        //         errorMessage = t(`errors.youtube_video.not_found`);
        //         break;
        //     case 101:
        //     case 150:
        //         errorMessage = t(`errors.youtube_video.restricted`);
        //         break;
        //     default:
        //         errorMessage = t(`errors.youtube_video.unknown`);
        // }

        setYoutubeVideoError(true);
    }, []);

    const getYoutubeVideoID = useCallback(() => {
        const url = data.game.youtube;

        var regExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)[\w\-]{11}(?:[&?][^\s]*)?$/;
        var match = url.match(regExp);

        if (match) {
            const regExp = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
            return regExp.exec(url)[3];
        }
        else {
            setYoutubeVideoError(true);
            return null;
        }
    }, []);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='center'
                alignItems='center'
                className="bodyPadding navigationSpace"
            >
                <div 
                    style={{ 
                        width: '100%', 
                        height: `${height}px`, 
                        position: 'absolute',
                        zIndex: 1,
                        top: 100,
                        display: isMobile ? 'none' : 'flex'
                    }}
                >
                    <Particles
                        particleColors={['#ffffff', '#ffffff']}
                        particleCount={250}
                        particleSpread={10}
                        speed={0.1}
                        particleBaseSize={100}
                        moveParticlesOnHover={false}
                        alphaParticles={false}
                        disableRotation={false}
                    />
                </div>

                {
                    // Mobile view
                    isMobile
                    ?
                    <Box
                        sx={{
                            width: '100%',
                            mt: 2,
                            zIndex: 2
                        }}
                    >
                        {
                            !data.game.youtube || youtubeVideoError
                            ?
                            <img 
                                src="/images/game/Gameplay.jpg" 
                                alt="Game play" 
                                width='100%'
                            />
                            :
                            <Box width='100%' sx={{backgroundColor: 'black'}}>
                                <YouTube 
                                    videoId={getYoutubeVideoID()}
                                    opts={{
                                        width: '100%',
                                        height: 250,
                                        playerVars: {
                                            // https://developers.google.com/youtube/player_parameters
                                            autoplay: 0,
                                            color: 'white'
                                        }
                                    }}
                                    onError={OnYoutubeError}
                                    onReady={() => setYoutubeVideoError(false)}
                                />
                            </Box>
                        }
                    </Box>
                    // Pc view
                    :
                    isViewWidthSmall
                    ?
                    <iframe 
                        src={process.env.REACT_APP_GAME_URL}
                        title="Game play"
                        loading="eager"
                        allowFullScreen
                        style={{
                            width: '100%',
                            border: '2px solid white',
                            aspectRatio: 1.77,
                            marginTop: '20px',
                            zIndex: 2,
                            backgroundColor: 'white'
                        }}
                    />
                    :
                    <iframe 
                        src={process.env.REACT_APP_GAME_URL}
                        title="Game play"
                        loading="eager"
                        allowFullScreen
                        style={{
                            height: `${height}px`,
                            border: '2px solid white',
                            aspectRatio: 1.77,
                            marginTop: '20px',
                            zIndex: 2,
                            backgroundColor: 'white'
                        }}
                    />
                }

                <Link
                    to={data.store.play_store}
                    target="_blank"
                    style={{
                        zIndex: 2
                    }}
                >
                    <Box
                        sx={{
                            width: 200,
                            '&: hover': {
                                transform: 'scale(0.9)'
                            },
                            animation: 'downloadBtn 2s infinite 1s'
                        }}
                        py={{xs: 2, md: 5}}
                    >
                        <img 
                            src="/images/icons/Playstore icon.png" 
                            alt="Play store" 
                            width='100%'
                        />
                    </Box>
                </Link>
            </Stack>
        </>
    );
}

export default GamePlayView;